import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  countRequestInLine: 3,
};

const calendarEventSlice = createSlice({
  name: "calendarEvent",
  initialState,
  reducers: {
    updateCountRequestInList: (state, { payload }) => {
      state.countRequestInLine = payload;
    },
  },
});

export const { updateCountRequestInList } = calendarEventSlice.actions;
export const calendarEventReducer = calendarEventSlice.reducer;
